// dev-vehicle-request — site-wide "Can't find your vehicle?" request form.
// ───────────────────────────────────────────────────────────────────────────
// Standalone modal wrapping a Shopify {% form 'contact' %} (Figma 591-15672).
// Opened from the PDP fitment block's "Can't Find Your Vehicle?" link and the
// homepage "Your Garage" section's help link — both are plain
// [data-dev-vehicle-request-open] triggers caught by the delegated listener below.
//
// Markup: snippets/dev-vehicle-request.liquid. Styling reuses .dev-smr__* /
// .dev-smr__request-* / .dev-smr__field-* from assets/dev-shop-my-ride.css.
//
// Opening: a click on any [data-dev-vehicle-request-open] element, or a
// `dev-vehicle-request:open` event dispatched on document. Submit is a native
// Shopify contact-form POST; after the reload the server-rendered feedback line
// ([data-dvr-feedback]) re-opens the modal so the shopper sees the outcome.

(function () {
  'use strict';

  const NAME = 'dev-vehicle-request';
  if (customElements.get(NAME)) return;

  const q = (root, sel) => root.querySelector(sel);

  customElements.define(
    NAME,
    class extends HTMLElement {
      #initialized = false;
      #onKeydown = null;
      #onOpen = null;
      #onDocClick = null;

      connectedCallback() {
        if (this.#initialized) return;
        this.#initialized = true;

        this.modalEl = q(this, '[data-dvr-modal]');
        if (!this.modalEl) return;

        this.#bind();
        // After a contact-form POST the page reloads; if the server rendered a
        // success/error line, re-open the modal to show it.
        if (this.modalEl.querySelector('[data-dvr-feedback]')) this.open();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.#onKeydown);
        document.removeEventListener('dev-vehicle-request:open', this.#onOpen);
        document.removeEventListener('click', this.#onDocClick);
      }

      #bind() {
        // Close: X / scrim / Esc
        this.querySelectorAll('[data-dvr-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.#onKeydown = (e) => {
          if (e.key === 'Escape' && !this.modalEl.hidden) this.close();
        };
        document.addEventListener('keydown', this.#onKeydown);

        // Open: any [data-dev-vehicle-request-open] trigger (delegated so it can live
        // anywhere on the page) or a programmatic `dev-vehicle-request:open` event.
        this.#onDocClick = (e) => {
          const trigger = e.target.closest && e.target.closest('[data-dev-vehicle-request-open]');
          if (trigger) { e.preventDefault(); this.open(); }
        };
        document.addEventListener('click', this.#onDocClick);
        this.#onOpen = () => this.open();
        document.addEventListener('dev-vehicle-request:open', this.#onOpen);
      }

      open() {
        this.modalEl.hidden = false;
        document.body.style.overflow = 'hidden';
        const first = q(this, '.dev-smr__field-input');
        if (first) { try { first.focus({ preventScroll: true }); } catch { /* older browsers */ } }
      }

      close() {
        this.modalEl.hidden = true;
        document.body.style.overflow = '';
      }
    },
  );
})();
